<template>
  <article>
    <tab-list
      :tab-list="tabList"
      :status.sync="tabStatus"
      @tab-change="onShiftTab">
    </tab-list>
    <second-sel
      :store-name="storeName"
      :flag.sync="flagA"
      :selList="tabObj[tabStatus]"
      @select-tab="selectTab">
    </second-sel>
    <data-summary
      :title-list="summaryTitle"
      :data-list="summaryData">
    </data-summary>
    <data-table
      table-title="续保专员"
      :title-list="assigneesTable"
      :data-list="assigneesData">
    </data-table>
    <!-- 单店每月的续保统计 -->
    <div v-show="tabStatus === 'monthly'">
      <data-table
        table-title="客户类型"
        :title-list="customerTable"
        :data-list="customerData">
      </data-table>
      <data-table
        table-title="保险公司"
        :title-list="companieTable"
        :data-list="companiesData">
      </data-table>
      <data-table
        table-title="商业险险种"
        :title-list="commercialTable"
        :data-list="commercialData">
      </data-table>
    </div>
  </article>
</template>
<script>
import util from '../../common/util'
import TabList from '../components/TabList'
import SecondSel from './components/SecondSel'
import DataSummary from './components/DataSummary'
import DataTable from './components/DataTable'
const day = new Date()
const today = util.formatTime(day, 'yyyy-MM-dd')
const yesterday = util.formatTime(day.valueOf() - 24 * 3600 * 1000, 'yyyy-MM-dd')
const thisMonth = util.formatTime(day, 'yyyy-MM')
const lastMonth = util.getLastMonth(thisMonth)
export default {
  components: {
    TabList,
    SecondSel,
    DataSummary,
    DataTable
  },
  data() {
    return {
      storeId: '',
      storeName: '',
      tabStatus: 'monthly',
      flagA: thisMonth, // 默认日期是本月
      tabList: [
        { key: 'daily', name: '日' },
        { key: 'monthly', name: '月' }
      ],
      tabObj: {
        daily: [
          { key: today, name: '今日' },
          { key: yesterday, name: '昨日' }
        ],
        monthly: [
          { key: thisMonth, name: '本月' },
          { key: lastMonth, name: '上个月' }
        ]
      },
      // 数据概览
      summaryTitle: [],
      summaryData: {},
      dailySummary: [
        { key: 'ins_orders_count', name: '保单合计' },
        { key: 'ins_premiums_total', name: '保费合计' },
        { key: 'ins_premiums_avg', name: '保单均价' },
        { key: 'ins_quotes_count', name: '报价数（次）' }
      ],
      monthlySummary: [
        { key: 'ins_expires_count', name: '到期客户' },
        { key: 'ins_completed', name: '续回客户' },
        { key: 'ins_completed_rate', name: '续回率' },
        { key: 'ins_orders_count', name: '保单合计' },
        { key: 'ins_premiums_total', name: '保费合计' },
        { key: 'ins_premiums_avg', name: '保单均价' },
        { key: 'ins_quoted', name: '已报价(人)' },
        { key: 'ins_cars_count', name: '保有车辆总数' }
      ],
      // 续保专员
      assigneesData: [],
      assigneesTable: [],
      dailyAssigneesTable: [
        { key: 'name', name: '续保专员' },
        { key: 'ins_quotes_count', name: '报价数（次）' },
        { key: 'ins_orders_count', name: '保单合计' },
        { key: 'ins_premiums_total', name: '保费合计' }
      ],
      monthlyAssigneesTable: [
        { key: 'name', name: '续保专员' },
        { key: 'ins_expires_count', name: '到期客户' },
        { key: 'ins_quoted', name: '已报价（人）' },
        { key: 'ins_completed', name: '续回客户' },
        { key: 'ins_completed_rate', name: '续回率%' },
        { key: 'ins_orders_count', name: '保单合计' },
        { key: 'ins_premiums_total', name: '保费合计' }
      ],
      // 客户类型
      customerData: [],
      customerTable: [
        { key: 'name', name: '客户类型' },
        { key: 'ins_expires_count', name: '到期客户' },
        { key: 'ins_completed', name: '续回客户' },
        { key: 'ins_completed_rate', name: '续回率%' },
        { key: 'ins_orders_count', name: '保单合计' },
        { key: 'ins_premiums_total', name: '保费合计' }
      ],
      // 保险公司
      companiesData: [],
      companieTable: [
        { key: 'name', name: '保险公司' },
        { key: 'ins_orders_count', name: '保单合计' },
        { key: 'order_rate', name: '保单占比%' },
        { key: 'ins_premiums_total', name: '保费合计' },
        { key: 'premium_rate', name: '保费占比%' }
      ],
      // 商业险险种
      commercialData: [],
      commercialTable: [
        { key: 'name', name: '险种' },
        { key: 'ins_orders_count', name: '关联保单' },
        { key: 'order_rate', name: '渗透率%' }
      ]
    }
  },
  mounted() {
    this.storeId = +this.$route.params.id
    // 默认获取月数据
    this.selectData(this.flagA)
  },
  methods: {
    onShiftTab() {
      this.flagA = this.tabObj[this.tabStatus][0].key
      this.selectData(this.flagA)
    },
    selectTab() {
      this.selectData(this.flagA)
    },
    selectData(day) {
      let queryDay = this.tabStatus === 'daily' ? day : `${day}-01`
      let params = {
        date: queryDay
      }
      this.switchLoading({ status: true, text: '加载中...' })
      this.$rest.dataAnalysis.getInsuranceData(params, `${this.tabStatus}/${this.storeId}`).then(res => {
        if (res.code === 0) {
          let countData = res.data[this.flagA]
          this.storeName = res.data.name
          // 数据概览
          this.summaryTitle = this[`${this.tabStatus}Summary`]
          this.summaryData = this.getSummary(countData.total)
          // 续保专员
          this.assigneesTable = this[`${this.tabStatus}AssigneesTable`]
          this.assigneesData = this.getFormateData(countData.assignees_detail)
          if (this.tabStatus === 'monthly') {
            // 客户类型
            this.customerData = this.getFormateData(countData.customer_rating_detail)
            // 保险公司
            this.companiesData = this.getFormateData(countData.ins_companies_detail)
            // 商业险险种
            this.commercialData = this.getFormateData(countData.commercial_ins_detail)
          }
        } else {
          this.showToast(res.message)
        }
        this.switchLoading({ status: false })
      })
    },
    formatePrice(number) {
      number = number || 0
      return (number / 100).toFixed(2)
    },
    formateRate(number) {
      number = number || 0
      return (number * 100).toFixed(2) + '%'
    },
    getFormateData(arr) {
      arr.forEach(v => {
        if (v.ins_premiums_total) v.ins_premiums_total = this.formatePrice(v.ins_premiums_total)
        if (v.ins_premiums_avg) v.ins_premiums_avg = this.formatePrice(v.ins_premiums_avg)
        if (v.ins_completed_rate) v.ins_completed_rate = this.formateRate(v.ins_completed_rate)
        if (v.order_rate) v.order_rate = this.formateRate(v.order_rate)
        if (v.premium_rate) v.premium_rate = this.formateRate(v.premium_rate)
      })
      return arr
    },
    getSummary(summary) { // 指标数据展览
      // 收车均价可能为null,需要转换单位
      summary.ins_premiums_total = this.formatePrice(summary.ins_premiums_total)
      summary.ins_premiums_avg = this.formatePrice(summary.ins_premiums_avg)
      if (summary.ins_completed_rate) summary.ins_completed_rate = this.formateRate(summary.ins_completed_rate)
      return summary
    }
  }
}

</script>
<style lang="less">
</style>
